//export const LANDING = '/';



export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const PASSWORD_FORGET = '/pw-forget';
export const ADMIN_DETAILS = '/admin/:id'; //The :id is a placeholder for a user identifier to be used later. If you want to be more specific, you could have used /admin/users/:id as well.



//export const LOGIN = '/login';
export const HOME = '/#home';
export const SIGN_IN = '/signin';
export const SIGN_UP = '/signup';

export const ADMIN_AREA_HOME = '/adminArea/Home';
export const ADMIN_AREA_ABOUT_US = '/adminArea/aboutUs';
export const ADMIN_AREA_PRICES = '/adminArea/prices';
export const ADMIN_AREA_TEAM = '/adminArea/team';
export const ADMIN_AREA_CONTACT = '/adminArea/contact';